import React, { PureComponent } from "react";
import { ClassificationLayer, GradientLayer } from "@gago-react-gl/gago-react-gl";
import { ClassificationLegend3, GradientLegend1, GradientIntervalLegend2 } from "@gago/frame";
import { colorPalette } from "../../color-palette";
import { isEqual } from "lodash";
import moment from "moment";
import { getPublisherUrls } from "../../utils/common-function";
// tslint:disable:jsx-no-multiline-js max-classes-per-file ter-max-len

/**
 * 土地类型地图图层
 * @author 马俊峰
 * @date 2020-07-28
 * @export
 * @class LandTypeLayer
 * @extends {PureComponent}
 */
export class LandTypeLayer extends PureComponent {
  render() {
    return (
      <>
        <ClassificationLayer<{ c0: "c0"; c1: "c1"; c2: "c2"; c3: "c3"; c4: "c4"}>
          id="map_type_layer"
          url={getPublisherUrls("https://api.gagogroup.cn/publisher/v2/data/landtype/20200811/{z}/{x}/{y}/lerc?token=53ee4f2b4e9c335be971df5142a6c43f20056ee69b9d069c36df996f70a413ad360b36ed39c5e4e58a8755e5b2299b9024af7f08f4a15082b954f09bd1421614760eda6c3c009dbe15eff3f8ff23d7fb4a5fdd88c1c4ee1b7348f60c869056c376c1c724d9f8a21cb9272b659aba4031f7476c3894e59d069e74ef63a3aa01fd")}
          paintUrl={"https://api.gagogroup.cn/publisher/v2/colour/landtype?token=53ee4f2b4e9c335be971df5142a6c43f20056ee69b9d069c36df996f70a413ad360b36ed39c5e4e58a8755e5b2299b9024af7f08f4a15082b954f09bd1421614760eda6c3c009dbe15eff3f8ff23d7fb4a5fdd88c1c4ee1b7348f60c869056c376c1c724d9f8a21cb9272b659aba4031f7476c3894e59d069e74ef63a3aa01fd"}
          insideSorts={{ c0: [9, 11], c1: [11, 21], c2: [21, 61], c3: [61, 81], c4: [81, 205.8] }}
          insideActiveSorts={"all"}
          before="zengcheng_outline_layer"
          maskSourceId="zengcheng_town_hight_fill_mask"
        >
          { colors => (
            <ClassificationLegend3
              {...{ ...colors }}
              theme="dark"
              style={{ position: "absolute", bottom: "16px", right: "0px" }}
              names={["耕地", "林地", "水域", "城镇", "其它"]}
              colorPalette={colorPalette}
            />
          )}
        </ClassificationLayer>
      </>
    );
  }
}

/**
 * 土地类型地图图层
 * @author 马俊峰
 * @date 2020-07-28
 * @export
 * @class LandTypeLayer
 * @extends {PureComponent}
 */
export class RiceTypeLayer extends PureComponent {
  render() {
    return (
      <>
        <ClassificationLayer<{
          c0: "c0"; c1: "c1";
        }>
          id="map_type_layer"
          url={getPublisherUrls("https://api.gagogroup.cn/publisher/v2/data/rice_area/20200713/{z}/{x}/{y}/lerc?token=53ee4f2b4e9c335be971df5142a6c43f20056ee69b9d069c36df996f70a413ad360b36ed39c5e4e58a8755e5b2299b9024af7f08f4a15082b954f09bd1421614760eda6c3c009dbe15eff3f8ff23d7fb4a5fdd88c1c4ee1b7348f60c869056c376c1c724d9f8a21cb9272b659aba4031f7476c3894e59d069e74ef63a3aa01fd")}
          paintUrl={"https://api.gagogroup.cn/publisher/v2/colour/rice_area?token=53ee4f2b4e9c335be971df5142a6c43f20056ee69b9d069c36df996f70a413ad360b36ed39c5e4e58a8755e5b2299b9024af7f08f4a15082b954f09bd1421614760eda6c3c009dbe15eff3f8ff23d7fb4a5fdd88c1c4ee1b7348f60c869056c376c1c724d9f8a21cb9272b659aba4031f7476c3894e59d069e74ef63a3aa01fd"}
          insideSorts={{ c0: [1, 10], c1: [10, 12] }}
          insideActiveSorts={"all"}
          before="zengcheng_outline_layer"
          maskSourceId="zengcheng_town_hight_fill_mask"
        >
          { colors => (
            <ClassificationLegend3
              {...{ ...colors }}
              theme="dark"
              style={{ position: "absolute", bottom: "16px", right: "0px" }}
              title="作物类型"
              names={["早稻", "晚稻"]}
              colorPalette={colorPalette}
            />
          )}
        </ClassificationLayer>
      </>
    );
  }
}

/** 获取包括今天未来七天的日期列表 */
export function getNextSevenDaysList() {
  const dateList: string[] = [];
  for (let num = 0; num < 7; num++) {
    const date = moment().add(num, "days").format("YYYY-MM-DD");
    dateList.push(date);
  }
  return dateList;
}

interface Props {
  /** 选择地图展示时间 */
  date: string;
}
interface State {
  /** 地图渲染展示的时间 */
  showDate: string;
}
/**
 * 高温地图
 * @author 马俊峰
 * @date 2020-07-29
 * @export
 * @class TmaxLayer
 * @extends {PureComponent<Props, State>}
 */
export class TmaxLayer extends PureComponent<Props, State> {
  state: State = {
    showDate: "",
  };
  /** props监测响应 */
  static getDerivedStateFromProps(props: Props, state: State) {
    if (!isEqual(state.showDate, props.date)) { return { showDate: props.date }; }
    return null;
  }
  render() {
    const { showDate } = this.state;
    const dataDay = moment().subtract(1, "days").format("YYYYMMDD");
    const useShowDate = moment(showDate).format("YYYYMMDD");
    return (
      <>
        <GradientLayer
          id="map_type_layer"
          url={`${window.config.publisher}/api/v1/cloud/1weather/${dataDay}/TMAX/${useShowDate}/{z}/{x}/{y}.lerc`}
          colorscaleType="exponential"
          colors={[
            "#300056",
            "#080d68",
            "#0c43c4",
            "#3492f4",
            "#95cff2",
            "#fffdc6",
            "#ffe479",
            "#f27d06",
            "#e34e1e",
            "#640117",
            "#480012",
          ]}
          positions={[263.15, 269.15, 275.15, 281.15, 287.15, 293.15, 299.15, 305.15, 311.15, 317.15, 323.15]}
          valueMax={323.16}
          valueMin={223.14}
          sourceMaxzoom={18}
          sourceMinzoom={2}
          before="zengcheng_outline_layer"
          maskSourceId="zengcheng_town_hight_fill_mask"
        >
          { colors => (
            <GradientLegend1
              {...{ ...colors }}
              theme="dark"
              title="最高温"
              unit="单位：℃"
              style={{ position: "absolute", bottom: "0px", right: "0px" }}
              names={["-10", "-4", "2", "8", "14", "20", "26", "32", "38", "44", "50"]}
              colorPalette={colorPalette}
            />
          )}
        </GradientLayer>
      </>
    );
  }
}

/**
 * 低温地图
 * @author 马俊峰
 * @date 2020-07-29
 * @export
 * @class TminLayer
 * @extends {PureComponent<Props, State>}
 */
export class TminLayer extends PureComponent<Props, State> {
  state: State = {
    showDate: "",
  };
  /** props监测响应 */
  static getDerivedStateFromProps(props: Props, state: State) {
    if (!isEqual(state.showDate, props.date)) { return { showDate: props.date }; }
    return null;
  }
  render() {
    const { showDate } = this.state;
    const dataDay = moment().subtract(1, "days").format("YYYYMMDD");
    const useShowDate = moment(showDate).format("YYYYMMDD");
    return (
      <>
        <GradientLayer
          id="map_type_layer"
          url={`${window.config.publisher}/api/v1/cloud/1weather/${dataDay}/TMIN/${useShowDate}/{z}/{x}/{y}.lerc`}
          colorscaleType="exponential"
          colors={[
            "#300056",
            "#080d68",
            "#0c43c4",
            "#3492f4",
            "#95cff2",
            "#fffdc6",
            "#ffe479",
            "#f27d06",
            "#e34e1e",
            "#640117",
            "#480012",
          ]}
          positions={[263.15, 269.15, 275.15, 281.15, 287.15, 293.15, 299.15, 305.15, 311.15, 317.15, 323.15]}
          valueMax={323.16}
          valueMin={223.14}
          sourceMaxzoom={18}
          sourceMinzoom={2}
          before="zengcheng_outline_layer"
          maskSourceId="zengcheng_town_hight_fill_mask"
        >
          { colors => (
            <GradientLegend1
              {...{ ...colors }}
              theme="dark"
              title="最低温"
              unit="单位：℃"
              style={{ position: "absolute", bottom: "0px", right: "0px" }}
              names={["-10", "-4", "2", "8", "14", "20", "26", "32", "38", "44", "50"]}
              colorPalette={colorPalette}
            />
          )}
        </GradientLayer>
      </>
    );
  }
}

/**
 * 暴雨地图
 * @author 马俊峰
 * @date 2020-07-29
 * @export
 * @class ApcpLayer
 * @extends {PureComponent<Props, State>}
 */
export class ApcpLayer extends PureComponent<Props, State> {
  state: State = {
    showDate: "",
  };
  /** props监测响应 */
  static getDerivedStateFromProps(props: Props, state: State) {
    if (!isEqual(state.showDate, props.date)) { return { showDate: props.date }; }
    return null;
  }
  render() {
    const { showDate } = this.state;
    const dataDay = moment().subtract(1, "days").format("YYYYMMDD");
    const useShowDate = moment(showDate).format("YYYYMMDD");
    return (
      <>
        <GradientLayer
          id="map_type_layer"
          url={`${window.config.publisher}/api/v1/cloud/1weather/${dataDay}/APCP/${useShowDate}/{z}/{x}/{y}.lerc`}
          colorscaleType="exponential"
          colors={[
            "#a4ffff",
            "#3abfff",
            "#3984ff",
            "#204cff",
            "#7b20bf",
            "#5b1ec4",
          ]}
          positions={[1, 10, 25, 50, 100, 200]}
          valueMax={350}
          valueMin={0.001}
          sourceMaxzoom={18}
          sourceMinzoom={2}
          before="zengcheng_outline_layer"
          maskSourceId="zengcheng_town_hight_fill_mask"
        >
          { colors => (
            <GradientIntervalLegend2
              {...{ ...colors }}
              theme="dark"
              title="降水"
              unit="单位：mm"
              style={{ position: "absolute", bottom: "0px", right: "0px" }}
              names={["1 ~ 10", "10 ~ 25", "25 ~ 50", "50 ~ 100", "100 ~ 200", ">200"]}
              colorPalette={colorPalette}
            />
          )}
        </GradientLayer>
      </>
    );
  }
}
